export { default } from './modules/JavascriptTimeAgo'

export
{
	intlDateTimeFormatSupported as intlDateTimeFormatSupported,
	intlDateTimeFormatSupportedLocale as intlDateTimeFormatSupportedLocale
}
from './modules/locale'

export { default as RelativeTimeFormat } from './modules/RelativeTimeFormat'


//////////////////
// WEBPACK FOOTER
// ./~/javascript-time-ago/index.js
// module id = 672
// module chunks = 0